<template>
  <v-card flat>
    <v-card-title class="pa-1 pt-0 pb-2">
      <v-text-field solo dense hide-details ref="scanFocus" v-model="scanNumber" autocomplete="off"
        @change="getRespectiveSupplierOrder"
        :placeholder="$t('message.dashboard.scanText')"></v-text-field>
    </v-card-title>
    <v-card-title class="pa-0 pl-2 pr-2">
      <v-btn x-small fab @click="previousList" :disabled="page === 1">
        <v-icon>mdi-chevron-left</v-icon>
      </v-btn>
      <h5 class="mx-auto">{{ $t('message.dashboard.receiveSupplierOrder') }}</h5>
      <v-badge bordered bottom color="primary accent-4" dot offset-x="10" offset-y="10" :value="filteredSuppliers && filteredSuppliers.length > 0">
        <v-btn icon small @click="openFilterMenu"><v-icon>mdi-filter</v-icon></v-btn>
      </v-badge>
      <span class="mr-3 mt-1 text-subtitle-2">{{ getPaginateData }}</span>
      <v-btn x-small fab @click="nextList" :disabled="hasNoNext">
        <v-icon>mdi-chevron-right</v-icon>
      </v-btn>
    </v-card-title>
    <v-card-text class="pa-1 pt-0 mt-2">
      <div class="text-center" v-if="loading">
        <v-progress-circular
          :size="70"
          :width="7"
          color="primary"
          indeterminate
        ></v-progress-circular>
      </div>
      <template v-for="(item, index) in listOfOrders">
        <order-item type="supplier" :key="index" :isList="true" :model="item"></order-item>
      </template>
      <template v-if="listOfOrders && listOfOrders.length <= 0">
        {{ $t('message.order.noOrderFound') }}
      </template>
    </v-card-text>
    <v-navigation-drawer v-model="filterDrawer" absolute right height="400px">
      <v-list dense>
        <v-list-item>
          <v-list-item-content>
            <v-list-item-title>
              {{ $t('message.common.filters') }}
              <v-btn color="error" class="float-right" icon id="warningClose" small @click="filterDrawer=false">
                <v-icon>mdi-close-circle</v-icon>
              </v-btn>
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-divider></v-divider>
        <v-row>
          <v-col cols="12">
            <v-autocomplete hide-details dense outlined multiple v-model="filteredSuppliers" :items="getSuppliers" item-text="name" item-value="id" :label="$t('message.order.selectSuppliers')">
              <template v-slot:selection="{ item, index }">
                <span v-if="index === 0">
                  <span>{{ item.name }}</span>
                </span>
                <span
                  v-if="index === 1"
                  class="grey--text text-caption"
                >
                  (+{{ filteredSuppliers.length - 1 }} {{ $t('message.common.others') }})
                </span>
              </template>
            </v-autocomplete>
          </v-col>
        </v-row>
        <v-divider></v-divider>
        <v-layout class="mt-2">
          <v-spacer></v-spacer>
          <v-btn color="green" dark id="filterOption" @click="applyFilter">
            <v-icon>mdi-filter-outline</v-icon>
          </v-btn>
          <v-btn color="error" id="removeFilterOption" class="ml-2" @click="resetFilter">
            <v-icon>mdi-filter-remove-outline</v-icon>
          </v-btn>
          <v-spacer></v-spacer>
        </v-layout>
      </v-list>
    </v-navigation-drawer>
  </v-card>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
  data () {
    return {
      listOfOrders: [],
      loading: false,
      page: 1,
      totalCount: 0,
      totalDbData: 0,
      scanNumber: '',
      perPage: 20,
      hasNoNext: false,
      filterDrawer: false,
      filteredSuppliers: []
    }
  },
  components: {
    'order-item': () => import('@/components/Order/OrderItem')
  },
  mounted () {
    requestAnimationFrame(() => {
      if (this.$refs.scanFocus) {
        this.$refs.scanFocus.focus()
      }
    })
    this.$store.dispatch('getSupplierList')
    this.getOrders()
  },
  watch: {
    page (val) {
      this.getOrders()
    }
  },
  computed: {
    ...mapGetters(['getSuppliers']),
    getPaginateData () {
      var showFrom = ((this.page - 1) * this.perPage) + 1
      var showTo = (showFrom - 1) + this.listOfOrders.length
      return this.totalDbData > 0 ? `${showFrom} - ${showTo} av ${this.totalDbData}` : ''
    }
  },
  methods: {
    openFilterMenu () {
      this.filterDrawer = true
    },
    applyFilter () {
      this.page = 1
      this.getOrders()
      this.filterDrawer = false
    },
    resetFilter () {
      this.page = 1
      this.filteredSuppliers = []
      this.getOrders()
      this.filterDrawer = false
    },
    getOrders () {
      this.loading = true
      let pageVal = this.page || 1
      let query = {
        'supplierIds': this.filteredSuppliers || [],
        'page': pageVal,
        'rowsperpage': this.perPage
      }
      this.$api.execute('post', 'warehouseorders/get_supplierorder_with_qty', query)
        .then((response) => {
          if (response.data) {
            let { items, total } = response.data
            this.totalDbData = total
            this.totalCount = Math.ceil(total / this.perPage)
            if (this.page === this.totalCount) this.hasNoNext = true
            this.listOfOrders = items
          } else {
            this.totalDbData = 0
            this.totalCount = 0
          }
        })
        .finally(() => {
          this.loading = false
        })
    },
    previousList () {
      this.page--
      this.checkIsNextEnabled()
    },
    nextList () {
      if (this.page === this.totalCount) this.hasNoNext = true
      else {
        this.page++
        this.hasNoNext = false
      }
    },
    checkIsNextEnabled () {
      if (this.page === this.totalCount) this.hasNoNext = true
      else {
        this.hasNoNext = false
      }
    },
    getRespectiveSupplierOrder () {
      if (this.scanNumber) {
        this.$api.execute('get', `/warehouseorders/get_order_by_number/${this.scanNumber}/1`)
          .then((response) => {
            if (response && response.data) {
              this.$router.push(`/supplier_orders/${response.data.id}`)
            } else {
              this.$root.$emit('snackbar', { snackbar: true, color: 'info', text: this.$t('message.order.noOrderFound') })
            }
          })
      }
    }
  }
}
</script>
